import styled from 'styled-components';

import { RefreshIcon } from '@/shared/assets/icons/refresh-icon';

export const SyncStatusIcon = styled(RefreshIcon)`
  && {
    height: 1.25rem;
    width: 1.25rem;
  }
`;
